'use strict';

var toolTip = require('base/components/toolTip');

// hotfix/DAB-3712 //
function validateProductOnInit() {
    let productData = JSON.parse($('#productData').val());
    let isLimitedAdded = JSON.parse($('#isLimitedAdded').val());
    var hasClickAndCollectOnCart = $('#hasClickAndCollect').length > 0 ? JSON.parse($('#hasClickAndCollect').val()) : false;
    var productIsAvailableOnlyCC = $('#availableOnlyCC').length > 0 ? JSON.parse($('#availableOnlyCC').val()) : false;
    var basketHasBigVolumeInside = JSON.parse($('#basketHasBigVolumeInside').val()) || false;
    var uniqueSize = $('#uniqueSize').length > 0 ? $('#uniqueSize') : null;
    let nonPurchasableProducts = productData.nonPurchasableProducts;
    if (productData.isLimited) {
        if (nonPurchasableProducts || isLimitedAdded) {
            $('.variationAttribute').addClass('d-none');
            $('.quantity').addClass('d-none');
            $('.load-islimited').addClass('d-none');
            $('.add-to-cart').prop('disabled', true);
            $('.add-to-cart-global').prop('disabled', true);
            $('.load-islimited-added').removeClass('d-none');
        } else if (!nonPurchasableProducts && !isLimitedAdded) {
            $('.variationAttribute').removeClass('d-none');
            $('.load-islimited').removeClass('d-none');
            $('.load-islimited-added').addClass('d-none');
        }
    } else {
        $('.variationAttribute').removeClass('d-none');
        $('.isLimited').addClass('d-none');
        $('.load-islimited-added').addClass('d-none');
    }

    if (!hasClickAndCollectOnCart && !basketHasBigVolumeInside) {
        $('[click-and-collect-modals]').attr('disabled', false);
    }

    if (hasClickAndCollectOnCart && (uniqueSize && uniqueSize.val() == 1)) {
        var uniqueParent = uniqueSize.parent('.variation-attribute-size');
        uniqueParent.trigger('click');
    }
}
// hotfix/DAB-3712 //
function validateFastShippingMsg() {
    let fastShippingMsgValue = $('#validationDataMsg').val();
    if (fastShippingMsgValue) {
        let fastShippingMsg = JSON.parse(fastShippingMsgValue);
        var today = new Date();
        var time = today.getHours() + ':' + today.getMinutes();
        $('#fastShippingText').remove('#fastShippingText');
        if (fastShippingMsg.timeLimit >= time) {
            $('.stamp-shipment-fastShipping').append('<span id="fastShippingText" class="stamp-shipment-fastShipping">' + fastShippingMsg.msgToday + '</span> ');
        } else {
            $('.stamp-shipment-fastShipping').append('<span id="fastShippingText" class="stamp-shipment-fastShipping">' + fastShippingMsg.msgNextDay + '</span> ');
        }
    }
}

function setSelectedMethodMsgIntoPdp(data) {
    if ((!data.emptyCurrentBasket || data.action !== 'reset') && !data.isReset) {
        $('[data-js-selected-method-container]').toggleClass('d-none', !data.setSelectedMethodMsg);
        $('[data-js-unavailable-method-container]').toggleClass('d-none', data.setSelectedMethodMsg);
    } else {
        $('[data-js-selected-method-container]').addClass('d-none');
        $('[data-js-unavailable-method-container]').addClass('d-none');
    }

    if (data.setSelectedMethodMsg) {
        $('[data-js-selected-method]').text(data.selectedMethodMsg);
        $('[data-js-selected-method]').addClass('m-selected');
    } else {
        $('[data-js-selected-method]').empty();
    }
}

function setSelectedShippingMethodCard(data) {
    var isNotSelectedDeliveryMethod = data.selectedOptionCc || data.selectedOptionHd;

    $('[data-js-hd-stock]').empty().text(data.warehouseStockMsg);
    $('[data-js-cc-stock]').empty().text(data.storesStockMsg);

    $('[data-js-hd-btn]').toggleClass('m-sm_disabled', !data.warehouseStock);
    $('[data-js-hd-btn]').toggleClass('m-active_method', data.selectedOptionHd);
    $('[data-js-cc-btn]').toggleClass('m-sm_disabled', !data.storesStock);
    $('[data-js-cc-btn]').toggleClass('m-active_method', data.selectedOptionCc);

    $('[data-js-hd-stock]').toggleClass('m-has_stock', data.warehouseStock);
    $('[data-js-cc-stock]').toggleClass('m-has_stock', data.storesStock);
    $('[data-js-hd-stock]').toggleClass('m-hasnt_stock', !data.warehouseStock);
    $('[data-js-cc-stock]').toggleClass('m-hasnt_stock', !data.storesStock);

    $('[data-js-cc-icon]').attr('xlink:href', data.ccIcon);
    $('[data-js-hd-icon]').attr('xlink:href', data.hdIcon);

    if (!isNotSelectedDeliveryMethod) {
        $('[data-js-selected-method]').empty();
    }
}

function setSelectedMaxQty(data) {
    var quantitySelectorInput = $('[data-js-quantity-selector-input]');

    if (!data.selectedStore) return;
    $('[data-js-unavailable-method-container]').removeClass('d-none');
    if (!data.setMaxQty) return;
    $('[data-js-unavailable-method-container]').addClass('d-none');
    quantitySelectorInput.attr('max', data.maxQty);
}

function setShippingMethod(action, setShippingToBasketUrl, initState) {
    const productId = $('#productSKU').text();

    const data = {
        action: action,
        productId: productId,
        postalCode: initState.postalCode,
        storeInfo: initState.storeInfo,
        shippingMethod: initState.shippingMethod,
        shippingMethodPrice: initState.shippingMethodPrice,
        shippingMethodDisplayName: initState.shippingMethodDisplayName
    };

    $.ajax({
        url: setShippingToBasketUrl,
        method: 'GET',
        data: data,
        success: function (data) {
            var displayAddToCartButton = data.variantAvailabilityObj.selectedOptionCc || data.variantAvailabilityObj.selectedOptionHd;
            var selectedStoreCC = data.variantAvailabilityObj.isCcShipment;
            $('[data-js-pdp-add-to-cart-button]').toggleClass('d-none', !displayAddToCartButton);
            $('[data-js-pdp-select-store-cc-button]').toggleClass('d-none', displayAddToCartButton);
            $('#shippingMethodsAvailability .close-first-modal').click();
            $('[data-js-shipping-methods-container]').addClass('d-none');
            $('[data-js-shipping-modal-reset-btn]').toggleClass('m-enabled', displayAddToCartButton);
            $('[data-js-shipping-modal-save-btn]').removeClass('m-enabled');
            $('#btn-add-to-cart').removeClass('disabled');
            $('#btn-add-to-cart').removeAttr('disabled');

            if (selectedStoreCC) {
                $('[data-js-perso-modal-btn]').prop('disabled', true);
            } else {
                $('[data-js-perso-modal-btn]').removeAttr('disabled');
            }

            setSelectedShippingMethodCard(data.variantAvailabilityObj);
            setSelectedMaxQty(data.maxProductQty);
            setSelectedMethodMsgIntoPdp(data);
        },
        error: function () {
            $('#shippingMethodsAvailability .close-first-modal').click();
            $('[data-js-shipping-methods-container]').addClass('d-none');
            $('[data-js-shipping-modal-reset-btn]').removeClass('m-enabled');
            $('[data-js-shipping-modal-save-btn]').removeClass('m-enabled');
        }
    });
}

function setAvailableShippingMethods(data) {
    var parser = new DOMParser();
    var response = parser.parseFromString(data, 'text/html');
    var selectedMethod = response.querySelector('[data-js-selected-method').value;

    $('[data-js-shipping-methods-container]').removeClass('d-none');
    $('[data-js-shipping-methods-accordion]').empty();
    $('[data-js-shipping-methods-hd]').empty();
    
    var ccMethods = response.querySelector('[data-js-shipping-methods-cc-container]');
    $('[data-js-shipping-methods-accordion]').append(ccMethods);
    
    var hdMethods = response.querySelector('[data-js-shipping-methods-hd-container]');
    $('[data-js-shipping-methods-hd]').append(hdMethods);

    selectedMethod === 'Retiro'
        ? $('[data-js-shipping-methods-cc]').addClass('active')
        : $('[data-js-shipping-methods-cc]').removeClass('active');
    selectedMethod === 'Envio' 
        ? $('[data-js-shipping-methods-hd]').addClass('active')
        : $('[data-js-shipping-methods-hd]').removeClass('active');
}

function getAvailableShippingMethods(data, searchUrl) {
    let postalCodeValue = $("[data-js-header-postal-code]").first().attr("data-js-header-postal-code-formatted");

    if (data.postalCode != postalCodeValue) {
        postalCodeValue = data.postalCode;
    }

    const $input = $(".modal-shipping-methods-availability-input");

    if (postalCodeValue !== "" && $input.length) {
        $input.val(postalCodeValue || "1033");
    }

    $('#shippingMethodsAvailability .modal-content').spinner().start();
    $.ajax({
        url: searchUrl,
        method: 'GET',
        data: data,
        success: function (data) {
            setAvailableShippingMethods(data);
            $.spinner().stop();
        },
        error: function () {
            $('[data-js-shipping-methods-container]').addClass('d-none');

            $('[data-js-shipping-methods-accordion]').empty();
            $('[data-js-shipping-methods-hd]').empty();
            $.spinner().stop();
        }
    });
}

function zoomOutMobile() {
    var viewport = document.querySelector('meta[name="viewport"]');

    if (viewport) {
        viewport.content = 'initial-scale=0.1';
        viewport.content = 'width=1200';
        viewport.content = 'initial-scale=1';
    }
}

$(document).ready(function () {
    const initState = {
        postalCode: '',
        storeInfo: '',
        shippingMethod: '',
        shippingMethodPrice: '',
        empty: true,
        shippingMethodDisplayName: ''
    };

    $('.slider-mobile-PDP').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: false,
        adaptiveHeight: true,
        infinite: true,
        useTransform: true,
        speed: 400
    });
    var currentSlideSliderMobilePDP;
    $('#carousel-pdp-modal').on('shown.bs.modal', function () {
        $('.slider-mobile-PDP-modal').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            fade: false,
            dots: false,
            adaptiveHeight: false,
            infinite: true,
            useTransform: false,
            speed: 400,
            initialSlide: currentSlideSliderMobilePDP
        });
        $('.slider-mini-mobile-PDP-modal')
            .on('init', function () {
                $('.slider-mini-mobile-PDP-modal .slick-slide.slick-current').addClass('is-active');
            })
            .slick({
                slidesToShow: 5,
                slidesToScroll: 4,
                arrows: false,
                dots: false,
                focusOnSelect: false,
                infinite: false,
                initialSlide: currentSlideSliderMobilePDP
            });
    });

    $('#carousel-pdp-modal').on('hidden.bs.modal', function () {
        $('.slider-mobile-PDP-modal').slick('unslick');
        $('.slider-mini-mobile-PDP-modal').slick('unslick');
        zoomOutMobile();
    });

    $('.nav-mobile-PDP').on('init', function () {
        $('.nav-mobile-PDP .slick-slide.slick-current').addClass('is-active');
    }).slick({
        slidesToShow: 5,
        slidesToScroll: 4,
        arrows: false,
        dots: false,
        focusOnSelect: false,
        infinite: false
    });

    $('.slider-mobile-PDP').on('afterChange', function (event, slick, currentSlide) {
        currentSlideSliderMobilePDP = currentSlide;
        if (currentSlide > 3 && $(window).width() > 599 && $(window).width() < 991) {
            $('.nav-mobile-PDP .slick-list.draggable .slick-track').css('margin-left', '400px');
        } else if (currentSlide < 4 && $(window).width() > 599 && $(window).width() < 991) {
            $('.nav-mobile-PDP .slick-list.draggable .slick-track').css('margin-left', '5px');
        }
        $('.nav-mobile-PDP').slick('slickGoTo', currentSlide);
        var currrentNavSlideElem = '.nav-mobile-PDP .slick-slide[data-slick-index="' + currentSlide + '"]';
        $('.nav-mobile-PDP .slick-slide.is-active').removeClass('is-active');
        $(currrentNavSlideElem).addClass('is-active');
    });

    $('.slider-mobile-PDP-modal').on('afterChange', function (event, slick, currentSlide) {
        if (currentSlide > 3 && $(window).width() > 599 && $(window).width() < 991) {
            $('.slider-mini-mobile-PDP-modal .slick-list.draggable .slick-track').css('margin-left', '400px');
        } else if (currentSlide < 4 && $(window).width() > 599 && $(window).width() < 991) {
            $('.slider-mini-mobile-PDP-modal .slick-list.draggable .slick-track').css('margin-left', '5px');
        }
        $('.slider-mini-mobile-PDP-modal').slick('slickGoTo', currentSlide);
        var currrentNavSlideElem = '.slider-mini-mobile-PDP-modal .slick-slide[data-slick-index="' + currentSlide + '"]';
        $('.slider-mini-mobile-PDP-modal .slick-slide.is-active').removeClass('is-active');
        $(currrentNavSlideElem).addClass('is-active');
    });

    $('[data-js-submit-postal-code]').on('click', function (e) {
        e.preventDefault();

        initState.storeInfo = '';
        initState.shippingMethod = '';
        initState.shippingMethodPrice = '';
        initState.shippingMethodDisplayName = '';
        initState.empty = true;

        var searchUrl = $('[data-js-submit-postal-code]').attr('data-url');
        var selectedTab = $('[data-js-modal-type]').val();
        $('[data-js-shipping-modal-save-btn]').removeClass('m-enabled');
        $('[data-js-shipping-modal-reset-btn]').removeClass('m-enabled');
        var namePerso = $('.nameSummary-PDP').text();
        var numberPerso = $('.numberSummary-PDP').text();
        var isPerso = false;
        if ((namePerso !== ''
            && namePerso != '\n '
            && namePerso !== undefined
            && namePerso !== null
            && namePerso !== ' ') ||
            (numberPerso != '\n '
            && numberPerso !== ''
            && numberPerso !== undefined
            && numberPerso !== null
            && numberPerso !== ' ')
        ) {
            isPerso = true;
        }
        var data = {
            pid: $('#productSKU').text(),
            postalCode: $('[data-js-zip-code-shipping]').val(),
            selectedTab: selectedTab,
            isPerso: isPerso
        };

        if (data.postalCode === undefined
            || data.postalCode === null
            || data.postalCode.length < 4
            || data.pid === undefined
            || data.pid === null) {
            return;
        }

        getAvailableShippingMethods(data, searchUrl);
    });

    $('[data-js-hd-btn]').on('click', function(e) {
        e.preventDefault();

        var element = $('[data-js-shipping-method-home-delivery]');

        element.removeClass('d-none');

        setTimeout(function () {
            element.addClass('d-none');
        }, 7000);
    });

    $('[data-js-display-shipping-methods]').on('click', function (e) {
        e.preventDefault();

        let postalCodeValue = $("[data-js-header-postal-code]").first().attr("data-js-header-postal-code-formatted");
        const $input = $(".modal-shipping-methods-availability-input");

        if (postalCodeValue !== "" && $input.length) {
            $input.val(postalCodeValue || "1033");
        }

        const havePostalCode = postalCodeValue !== '';
        const hasSelected = $('.variation-attribute-size.selected').length > 0;

        $('[data-js-with-postalcode-msg]').toggleClass('d-none', !havePostalCode);
        $('[data-js-without-postalcode-msg]').toggleClass('d-none', havePostalCode);

        var searchUrl = $('[data-js-submit-postal-code]').attr('data-url');
        var selectedTab = e.currentTarget.dataset.selectedTab;
        var modalTitle = $('[data-js-shipping-methods-title]');
        $('[data-js-modal-type]').val(selectedTab);
        var pid = $('#productSKU').text();

        var namePerso = $('.nameSummary-PDP').text();
        var numberPerso = $('.numberSummary-PDP').text();
        var isPerso = false;
        if ((namePerso !== ''
            && namePerso != '\n '
            && namePerso !== undefined
            && namePerso !== null
            && namePerso !== ' ') ||
            (numberPerso != '\n '
            && numberPerso !== ''
            && numberPerso !== undefined
            && numberPerso !== null
            && numberPerso !== ' ')
        ) {
            isPerso = true;
        }
        var data = {
            pid: pid,
            postalCode: $('[data-js-header-postal-code]').first().attr('data-js-header-postal-code-formatted') || '1033',
            selectedTab: selectedTab,
            isPerso: isPerso
        };

        if (data.pid === undefined
            || data.pid === null
            || !hasSelected) {
            $('[data-js-attr-size-label]').addClass('m-error');
            $(this).prop('disabled', true);

            return;
        } else {
            $('[data-js-attr-size-label]').removeClass('m-error');
        }

        if (selectedTab === 'Retiro') {
            modalTitle.empty().text('Opciones de retiro');
        } else {
            modalTitle.empty().text('Opciones de envío');
        }

        getAvailableShippingMethods(data, searchUrl);
    })

    $('[data-js-shipping-modal-save-btn]').on('click', function (e) {
        e.preventDefault();
        
        const url = $(this).data('url');
        const action = 'set';
        
        if (initState.empty ||
            initState.storeInfo === '' ||
            initState.shippingMethod === '' ||
            initState.shippingMethodPrice === '' ||
            initState.shippingMethodDisplayName === ''
        ) {
            return;
        }

        setShippingMethod(action, url, initState);
    });

    $('body').on('click', '[data-js-store-data]', function () {
        const elementParent = $(this).closest('[data-js-store-parent]')

        initState.postalCode = $('[data-js-zip-code-shipping]').val();
        initState.storeInfo = JSON.stringify(elementParent.data('storeInfo'));
        initState.shippingMethod = elementParent.data('shippingMethod');
        initState.shippingMethodPrice = elementParent.data('shippingMethodPrice');
        initState.shippingMethodDisplayName = elementParent.data('shippingMethodDisplayName');
        initState.empty = false;

        $('[data-js-shipping-modal-reset-btn]').addClass('m-enabled');
        $('[data-js-shipping-modal-save-btn]').addClass('m-enabled');
    });

    $('body').on('click', '[data-see-more-btn]', function () {
        const seeMoreBoolean = $(this).data('seeMoreBtn');

        $('[data-js-hidden-stores]').toggleClass('d-none', seeMoreBoolean);
        $('[data-js-hidden-stores]').toggleClass('d-flex', !seeMoreBoolean);

        $(this).data('seeMoreBtn', !seeMoreBoolean);

        if (seeMoreBoolean) {
            $(this).text('Ver más');
            $(this).removeClass("all-stores-shown");
        } else {
            $(this).text('Ver menos');
            $(this).addClass("all-stores-shown");
        }
    });

    $('[data-js-shipping-modal-reset-btn]').on('click', function (e) {
        if (initState.empty ||
            initState.storeInfo === '' ||
            initState.shippingMethod === '' ||
            initState.shippingMethodPrice === '' ||
            initState.shippingMethodDisplayName === ''
        ) {
            return;
        }

        initState.storeInfo = '';
        initState.shippingMethod = '';
        initState.shippingMethodPrice = '';
        initState.empty = true;
        initState.shippingMethodDisplayName = '';

        const url = $(this).data('url');
        const action = 'reset';

        $('[data-js-store-input]').prop('checked', false);
        $('[data-js-shipping-modal-reset-btn]').removeClass('m-enabled');
        $('[data-js-shipping-modal-save-btn]').removeClass('m-enabled');
        $('[data-js-shipping-method-data]').removeClass('show');
        $('[data-js-shipping-methods-container]').addClass('d-none');

        setShippingMethod(action, url, initState);
    });

    $('.nav-mobile-PDP').on('click', '.slick-slide', function (event) {
        event.preventDefault();
        var goToSingleSlide = $(this).data('slick-index');

        $('.slider-mobile-PDP').slick('slickGoTo', goToSingleSlide);
    });

    $('.slider-mini-mobile-PDP-modal').on('click', '.slick-slide', function (event) {
        event.preventDefault();
        var goToSingleSlide = $(this).data('slick-index');

        $('.slider-mobile-PDP-modal').slick('slickGoTo', goToSingleSlide);
    });

    $('[data-js-zip-code-shipping]').on('keydown', function (e) {
        if (e.code === 'Enter') {
            $('.modal-shipping-methods-availability-send-btn').trigger('click');
        }
    });
});

$(document).ready(function () {
    /** NET-939 BEGIN **/
    // Sending view_item Event GA4 AZ-19664
    try {
        var productGtmDataValue = $('#productGtmData').val();
        var productGtmData = JSON.parse(productGtmDataValue);
        delete productGtmData.currency;

        var productDetailsGtmEvent = {
            event: 'view_item',
            currency: 'ARG',
            value: productGtmData[0].price,
            ecommerce: {
                items: productGtmData
            }
        };

        if (typeof productDetailsGtmEvent === 'object' && productDetailsGtmEvent !== null){
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({ ecommerce: null });
            window.dataLayer.push(productDetailsGtmEvent); 
        }
    } catch (e) {
        // Nothing to do here
    }
    /** NET-939 END **/

    $('.add-to-wish-list .fa').on('click', function () {
        $(this).removeClass('fa-heart-o');
        $(this).addClass('fa-heart');
    });

    $('body').on('product:afterAttributeSelect', function (e, {
        data
    }) {
        if (data.product && data.product.availableToSellUnified) {
            const { hasLowStockNew, availableOnlyCC, lowStockMessageNewCC, lowStockMessageNewUnified } = data.product.availableToSellUnified;
            const storeImage =  $('input[name="storeImage"]').val();
            const StockContainer = $('.container-block-stocks');

            let messages = [];

            if (hasLowStockNew) {
                messages.push(`
            <div class="row low-stock-row low-stock-message">
                <div class="col-12">
                    <div class="saving-and-installments-container last-units pull-left">
                        <p class="low-stock">${lowStockMessageNewUnified}</p>
                    </div>
                </div>
            </div>`);
            }

            if (availableOnlyCC) {
                messages.push(`
                <div class="row low-stock-row cc-stock-message">
                    <button type="button" class="info-icon">
                        <div class="col-12">
                            <div class="saving-and-installments-container pull-left product-cc-msg" data-available-only-cc="true">
                                <svg role="presentation" class="ico-stores" viewBox="0 0 28 25" width="17px" height="18px">
                                            <use xlink:href="#storeHeaderSvg"></use>
                                        </svg>
                                    <p class="low-stock">${lowStockMessageNewCC}</p>
                                    <strong class="tooltip d-none">Sujeto a  <b>disponibilidad de stock</b> en sucursales</strong>
                            </div>
                    </button>
                </div>`);
            }

            if (messages.length > 0) {
                $('.product-basic-information .low-stock-row').remove();
                if (StockContainer.length) {
                    StockContainer.addClass('block-space');
                    $(StockContainer).prepend(messages.join(''));
                } else {
                    $('.product-detail').prepend(messages.join(''));
                }
                toolTip();
            } else {
                $('.product-basic-information .low-stock-row').remove();
                StockContainer.removeClass('block-space');
            }
        }
    });

    validateProductOnInit();
    validateFastShippingMsg();
    setInterval(validateFastShippingMsg, 60000);
});

$(document).ready(function () {
    const $zoneSelector = $('#zoneSelector');
    const $storeItems = $('[data-store-item]');
    const $noResultsMessage = $('#noResultStores');
    const $storesTotal = $('#storesTotal');
    const $resultsStoresMessage = $('#resultsStoresMessage');
    const $seeAllStores = $('#seeAllStores');
    const $storesAccordion = $('#storesAccordion');

    $zoneSelector.on('change', function () {
        const selectedValue = $zoneSelector.val().toLowerCase();
        let visibleStores = 0;

        $storeItems.each(function () {
            const $store = $(this);
            const storeLocations = $store
                .data('store-location')
                .split(',')
                .map(loc => loc.trim().toLowerCase());

            if (
                selectedValue === '' ||
                storeLocations.includes(selectedValue) ||
                (selectedValue.includes(',') &&
                    selectedValue.split(',').some(val => storeLocations.includes(val.trim())))
            ) {
                $store.show(); // Mostrar tienda
                visibleStores++;
            } else {
                $store.hide(); // Ocultar tienda
            }
        });

        if (visibleStores === 0) {
            $noResultsMessage.removeClass('d-none'); // Mostrar mensaje
            $resultsStoresMessage.addClass('d-none');
            $seeAllStores.addClass('d-none');
        } else {
            $noResultsMessage.addClass('d-none'); // Ocultar mensaje
            $seeAllStores.removeClass('d-none');
            $resultsStoresMessage.removeClass('d-none');
            $storesTotal.text(visibleStores);
        }

        if (visibleStores === 1) {
            $seeAllStores.addClass('d-none');
        }
    });

    $seeAllStores.on('click', function () {
        $seeAllStores.addClass('hide');
        $storesAccordion.addClass('see-more');
    });
});


function adjustQuickView() {
    setTimeout(() => {
        var windowWidth = $(window).width();
        if (windowWidth >= 991) {
            $('.product, .product-tile, .tile-body, .tile-image').hover(function () {
                $(this).find('.quickview-newContainer').css({
                    opacity: '1',
                    'z-index': '15'
                });
            }, function () {
                $(this).find('.quickview-newContainer').css({
                    opacity: '0',
                    'z-index': '0'
                });
            });
        }
    }, 2000);
    // Check if the window width is 991px or above

    // else{
    //     $('.quickview-newContainer').css({
    //         "opacity": "1",
    //         "z-index": "15"
    //     });
    // }
}

adjustQuickView();
